<template>
    <section class="login">
        <div class="container">
            <CardLoginSignup title="Welcome back" titleHighlight="[s1mus]: " subtitle="Log in with your account details"
                primaryActionButtonText="Log in" secondaryActionButtonText="Sign up" bottomText="Don't have an account?"
                primaryRedirect="/dashboard" secondaryRedirect="/signup" />
        </div>
        <div class="background">
            <div class="gradient animate-pan-overlay"></div>
            <div class="from-black"></div>
            <div class="noise"></div>
            <div>
                <img src="@/assets/img/bg-1simus.webp" alt="Background" class="bg-img" />
            </div>
        </div>
    </section>
</template>

<style scoped>
.login {
    position: relative;
    gap: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 0;
    overflow: hidden;
    width: 100%;
    height: 100svh;
}

@keyframes blink {

    0%,
    21%,
    79%,
    100% {
        opacity: 0;
    }

    29%,
    71% {
        opacity: 1;
    }
}

.pseudo-blink:after {
    animation: blink 1.2s ease infinite;
    background-color: var(--content-3-pair);
    content: "";
    display: inline-block;
    height: 0.7em;
    width: 0.3em;
    transform: translate(-1px);
}

.background {
    position: absolute;
    width: 100vw;
    height: 100vh;
    z-index: -1;
}

.gradient {
    background: linear-gradient(#000000,#000000 3px, transparent 0, transparent 9px);
    background-size: 100% 10px;
    opacity: 0.05;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    position: absolute;
    pointer-events: none;
    z-index: 1;
}

.from-black {
    background: linear-gradient(to top, #0000004d, transparent);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 2;
}

.noise {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 2;
    background-image: url(@/assets/img/noise.gif);
    background-blend-mode: color-dodge;
    opacity: 0.03;
}

@keyframes pan-overlay {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: 0 -100%;
    }
}

.animate-pan-overlay {
    animation: pan-overlay 16s linear infinite;
}

.bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    animation: zoom-in-out 30s ease-in-out infinite;
}

@keyframes zoom-in-out {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}
</style>

<script>
import CardLoginSignup from '@/components/login-signup/CardLoginSignup.vue';

export default {
    name: 'LoginView',
    components: {
        CardLoginSignup
    }
};
</script>